import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "container",
    "triangle",
    "actionButton",
    "actionSelectionText",
]);
const baseStyle = {
    container: {
        position: "absolute",
        bottom: 0,
        transform: "translate(-50%, 50%)",
        left: "50%",
        zIndex: 100,
        paddingLeft: "8",
        color: "semantic.text.inverse",
        display: "inline-flex",
        gap: ".5rem",
        alignItems: "center",
        padding: ".25rem 0.5rem",
        background: "semantic.foreground.secondary",
    },
    triangle: {
        width: 0,
        height: 0,
        position: "absolute",
        left: 0,
        borderLeft: "24px solid",
        borderColor: "semantic.brand.tertiary",
        borderTop: "24px solid transparent",
        borderBottom: "24px solid transparent",
    },
    actionButton: {
        h: "56px",
        px: 3,
        py: 4,
        "*": {
            whiteSpace: "nowrap",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    actionSelectionText: {
        display: "inline-flex",
        overflow: "hidden",
        textOverflow: "ellipsis",
        marginLeft: 4,
    },
};
const BulkActionTheme = defineMultiStyleConfig({
    baseStyle,
});
export default BulkActionTheme;
//# sourceMappingURL=BulkAction.default.js.map